var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.279053C6 0.279053 1.73 3.38905 0 7.77905C1.73 12.1691 6 15.2791 11 15.2791C16.005 15.2791 20.27 12.1691 22 7.77905C20.27 3.38905 16.005 0.279053 11 0.279053ZM11 12.7791C8.24 12.7791 6 10.5391 6 7.77905C6 5.01905 8.24 2.77905 11 2.77905C13.76 2.77905 16 5.01905 16 7.77905C16 10.5391 13.76 12.7791 11 12.7791ZM11 4.77905C9.345 4.77905 8 6.12405 8 7.77905C8 9.43405 9.345 10.7791 11 10.7791C12.655 10.7791 14 9.43405 14 7.77905C14 6.12405 12.655 4.77905 11 4.77905Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.a0ad14bf127bd6d19e61d80c114f1cd1.svg";
export { ForwardRef as ReactComponent };